export const USUARIOS_PUEDEN_ELIMINAR = [
  "pat9000@hotmail.com",
  "ricardo.perez@escotel.com.mx",
  "emilio.rodriguez@escotel.com.mx",
];
